import { z } from 'zod';
/**
 * Non-secret tenant display fields, as handed out by Global-Admin
 * `GET /v1/orgs/by-subdomain/:slug` (`authScope: 'public'`).
 */
export const OrgBrandingSchema = z.record(z.unknown()).nullable();
/**
 * The body of `GET /bff/session`.
 *
 * ⚠️ AC1c — there is NO `tenantId` field here, and adding one must fail the
 * boot-time response-schema assert.
 *
 * Read the justification carefully, because the obvious one is wrong and will
 * not survive review: this is NOT a confidentiality control. Global-Admin
 * returns `tenantId` to any unauthenticated caller by design, and the US CRM
 * browser already fetches it (`US/src/lib/orgContext.tsx:98-105`). `tenantId`
 * is a public identifier. Withholding it here leaks nothing that isn't already
 * public one HTTP call away.
 *
 * It stays out because the BFF has no *reason* to emit it — the browser never
 * needs to name a tenant, since the BFF derives tenant from Host on every
 * request (AC1b). A route that suddenly starts emitting `tenantId` is a signal
 * that someone is building a flow where the client passes tenant back, which is
 * the actual thing we refuse. This is a lint anchor / defence-in-depth, and is
 * documented as such so nobody later "hardens" it on secrecy grounds.
 */
export const SessionResponseSchema = z.object({
    slug: z.string().min(1),
    displayName: z.string().min(1),
    branding: OrgBrandingSchema,
    /** ISO-8601 with explicit offset. Absolute session expiry (AC2: 24h). */
    expiresAt: z.string().min(1),
});
/**
 * Name of the funnel session cookie. HttpOnly + SameSite=Lax + first-party —
 * first-party because ADR-0002 §8 path-routes `/bff/*` and `/` on ONE host, and
 * US-Shop's Vite dev server proxies `/bff/*` → :3031 to mirror that locally.
 * If this cookie ever needs SameSite=None, the topology has regressed.
 */
export const SESSION_COOKIE_NAME = 'enr_sid';
//# sourceMappingURL=session.js.map